import React, { useEffect, useState } from 'react';

import AddressForm from './AddressForm';
import { ApolloError } from '@apollo/client';
import ErrorPanel from './ErrorPanel';
import Profile from '../models/Profile';
import ProfileFieldInputVm from '../models/ProfileFieldInputVm';
import ProfileFieldValue from '../models/ProfileFieldValue';
import UserProfileFieldControls from './UserProfileFieldControls';

interface UserProfileEditorProps {
  userkey?: number;
  hideSubFields: boolean;
  indicateErrorOnLoad: boolean; // * true: empty field is allowed on load (e.g. in Registration)
  loading: boolean;
  error: ApolloError;
  profileFields: Profile[];
  userProfileFields: ProfileFieldValue[];
  values: ProfileFieldInputVm[];
  onChange: (input: ProfileFieldInputVm) => void;
}

const UserProfileEditor = (props: UserProfileEditorProps) => {
  const [allRequiredFilledIn, setAllRequiredFilledIn] = useState<boolean>();
  const [values, setValues] = useState<ProfileFieldInputVm[]>(props.values);

  useEffect(() => {
    setValues(props.values);
  }, [props.values]);

  if (props.loading) {
    return <p>Loading profile data...</p>;
  }

  if (props.error) {
    return <ErrorPanel title="Profile" message="Failed to load profile data" />;
  }

  if (props.profileFields && (!!!props.userkey || props.userProfileFields)) {
    const requiredFilledIn = props.profileFields
      ?.filter((p) => p.required)
      .every((p) =>
        p.fields.every(
          (f) =>
            props.userProfileFields?.find(
              (v) =>
                v.profilekey === f.profilekey &&
                v.fieldposition === f.fieldposition
            )?.value
        )
      );

    if (allRequiredFilledIn === undefined) {
      setAllRequiredFilledIn(requiredFilledIn);
    } else {
      return (
        <>
          {props?.profileFields?.map((profile) =>
            profile.title === 'Address' ? (
              <AddressForm
                key={profile.profilekey}
                hideSubFields={props.hideSubFields}
                indicateErrorOnLoad={props.indicateErrorOnLoad}
                profile={profile}
                values={values?.filter(
                  (v) => v.profilekey === profile.profilekey
                )}
                allRequiredFilledIn={allRequiredFilledIn}
                onChange={props.onChange}
              />
            ) : (
              <UserProfileFieldControls
                key={profile.profilekey}
                indicateErrorOnLoad={props.indicateErrorOnLoad}
                profile={profile}
                values={values?.filter(
                  (v) => v.profilekey === profile.profilekey
                )}
                onChange={props.onChange}
              />
            )
          )}
        </>
      );
    }

    return <p>Loading profile data...</p>;
  }

  return <p>Loading profile data...</p>;
};

export default UserProfileEditor;
